import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import BlueprintBackdrop from "../components/BlueprintBackdrop";
import BrandWordmark from "../components/BrandWordmark";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-12 relative overflow-hidden">
      <BlueprintBackdrop variant="hero" showIsometric={false} />

      <div className="relative w-full max-w-md z-10">
        <div className="flex justify-center mb-8">
          <BrandWordmark size="md" onClick={() => navigate('/')} />
        </div>

        <div className="glass-card p-8 text-center" data-testid="payment-cancel-card">
          <div className="w-14 h-14 rounded-full bg-[#FFF1C8] flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-7 h-7 text-[#8B5A00]" />
          </div>
          <span className="pre-headline-pill pre-headline-pill-warm mb-3 inline-flex">Cancelled</span>
          <h2 className="font-display font-black text-3xl text-foreground mb-2">Payment cancelled</h2>
          <p className="text-sm text-muted-foreground mb-6">
            Your payment was cancelled. Don&apos;t worry — your project draft has been saved.
            You can complete the payment anytime from your dashboard.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/dashboard')}
              className="pill-btn pill-btn-primary w-full justify-center"
              data-testid="go-to-dashboard-btn"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to dashboard
            </button>
            <button
              onClick={() => navigate('/project/new')}
              className="pill-btn pill-btn-secondary w-full justify-center"
            >
              Start new project
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
